import { render, staticRenderFns } from "./EocMedicationsV1Properties.vue?vue&type=template&id=395d449e&"
import script from "./EocMedicationsV1Properties.vue?vue&type=script&lang=js&"
export * from "./EocMedicationsV1Properties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Portal.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports